.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;
}

.shipmentStats {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 2rem;
}

.shipmentStatsHeader {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}

.shipmentStatsCardGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.pillGroup {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.pill {
  display: flex;
  padding: 0.25rem 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 9999px;
  cursor: pointer;
}
.pill:hover {
  background-color: var(--selectable-hover);
}
.pill.primary {
  background: var(--selectable-selected);
}
.pill.primary > span {
  color: var(--primary-enabled);
}
.shipmentFilterTag {
  display: flex;
  align-items: center;
}

.pageContent {
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
}

.tr {
  border-bottom: 1px solid var(--static-divider-standard);
  height: 4rem;
  margin-left: 5px;
}
.tr:last-child {
  border-bottom: 0px;
}

.th {
  border-bottom: 1px solid var(--static-divider-standard);
  text-align: left;
  vertical-align: middle;
}

.thead {
  height: 4rem;
}

.shipmentNameCell {
  display: inline-block;
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 3px;
  margin-left: 30px;
}

.dropdownContainer {
  margin-right: 30px;
}

.dropdownButtonIcon {
  color: var(--static-text-standard);
  font-size: 24px;
  cursor: pointer;
}

.table {
  width: 100%;
  background-color: var(--static-background-standard);
  border-radius: 10px;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.tableHeader {
  margin-bottom: 20px;
}

.shipmentName {
  margin-left: 30px;
}

.percentageReceivedContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.percentageReceivedText {
  color: var(--sentiment-text-positive);
}

.percentageReceivedLoader {
  background-color: var(--sentiment-text-positive);
  height: 5px;
  border-radius: 6px;
  margin-left: 10px;
}

.searchBarContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.shipmentTypeContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.bolButtonContainer {
  margin-left: 10px;
}

.downloadIcon {
  margin-left: 5px;
}

.bolSpinner::before, .bolSpinner::after {
  border-color: white;
}

.externalBadge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0rem 0.375rem;
  border-radius: 6px;
  color: var(--sentiment-text-neutral);
  background: var(--sentiment-background-neutral);
}
  